"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Plus, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specs = ["3500kg ATM Capacity for heavy loads", "Multi-stage Hydraulic Ram System", "Heavy-duty Slide-under Ramps included", "Fully Welded Hot Dipped Galvanised Chassis"];
export default function ProductShowcase() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="productshowcase" className="bg-secondary text-secondary-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div ref={leftRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <div className="flex items-center gap-4 flex-wrap">
                <span className="font-mono text-sm md:text-base tracking-wider text-primary uppercase">
                  Heavy Duty Equipment
                </span>

                <Badge variant="outline" className="border-secondary-foreground/20 text-secondary-foreground font-mono">
                  <MapPin className="size-3 mr-1.5" />
                  Location: Wagga Wagga NSW
                </Badge>
              </div>

              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold uppercase tracking-tight leading-tight">
                8x5 Hydraulic Tipper Trailer
              </h2>
            </div>

            <p className="text-secondary-foreground/80 text-lg leading-relaxed max-w-xl font-sans">
              Built for the toughest commercial and industrial environments, our
              8x5 Hydraulic Tipper Trailer delivers unmatched reliability and
              performance. Engineered with precision to handle heavy loads safely
              and efficiently, it's the perfect addition to your fleet for
              construction, landscaping, and material transport.
            </p>

            <div className="w-full max-w-xl">
              <h3 className="font-default text-xl font-semibold mb-4 border-b border-secondary-foreground/10 pb-2">
                Key Specifications
              </h3>

              <ul className="space-y-3">
                {specs.map((spec, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                    <Plus className="size-5 text-primary shrink-0 mt-0.5" />
                    <span className="font-sans text-secondary-foreground/90">
                      {spec}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="font-mono uppercase tracking-wider px-8">
                <Link to="https://bottomupprojects.com.au/contact/">
                  Enquire Now
                </Link>
              </Button>
            </div>
          </div>

          <div ref={rightRef} className={`relative transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="absolute -inset-4 border border-secondary-foreground/10 hidden md:block" />
            <div className="absolute -inset-8 border border-secondary-foreground/5 hidden lg:block" />

            <div className="relative group overflow-hidden border-2 border-secondary-foreground/20 bg-background/5 p-2">
              <div className="relative aspect-[4/3] overflow-hidden bg-muted">
                <img src="https://bottomupprojects.com.au/wp-content/uploads/2026/05/TP85old_3500kg_03.webp" alt="8x5 Hydraulic Tipper Trailer" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />

                <div className="absolute inset-0 bg-gradient-to-tr from-secondary/40 to-transparent mix-blend-multiply pointer-events-none" />
              </div>

              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}